module.exports = __webpack_public_path__ + "static/protected-car-03ceb79aa02bb14faae31bf0320eaa17.png";